module.exports = __webpack_public_path__ + "resources/img/sp_gnb.758fff6aacf3817c4d01ef8bbfc866b0.png";